/**
 * Elaastic Image - image
 *
 * @author Matej Svajger <hello@matejsvajger.com>
 */

import Promise from 'promise'

export default class {
  constructor (el) {
    this.img = el

    this._ready = el.complete && el.naturalWidth > 0

    el.onload = () => {
      this._ready = true
    }
  }

  ready () {
    return new Promise((resolve, reject) => {
      if (this._ready) {
        resolve()
      } else {
        this.img.addEventListener('load', () => resolve())
        this.img.addEventListener('error',
          () => reject(
            new Error('Failed loading image')
          )
        )
      }
    })
  }

  get width () {
    return this.img.width
  }

  get height () {
    return this.img.height
  }

  get size () {
    return {
      width: this.width,
      height: this.height
    }
  }

  get src () {
    return this.img.src
  }

  set src (value) {
    this.img.src = value
  }
}
